import React from "react";
import { icon } from "../../../config";
import { TableFormField } from "../FormFieldType";
import { FORM_ICONS_UPDATED } from "../FormsConstant";
import "./TableContainer.scss";

/**
 * TableContainer Component
 * Renders a table with a header similar to Grid Layout
 * @param {Object} element - The table element data
 * @param {Function} onElementUpdate - Callback to update element data
 * @param {Object} selectedElement - Currently selected element
 * @param {Function} onElementSelect - Callback to select an element
 * @param {Function} onTableDelete - Callback for deleting the entire table
 */
const TableContainer = ({ element, onElementUpdate, selectedElement, onElementSelect, onTableDelete }) => {
  const isSelected = selectedElement?.id === element.id;

  // Handle click on table container
  const handleTableClick = (event) => {
    // Only select table if clicking on the container itself, not on child elements
    if (event.target === event.currentTarget || event.target.classList.contains("table-container-inner")) {
      event.stopPropagation();
      onElementSelect(element);
    }
  };

  return (
    <div className={`table-layout-container ${isSelected ? "selected" : ""}`} onClick={handleTableClick} data-element-id={element.id}>
      {/* Table Header */}
      <div className='table-layout-header'>
        <div
          className='table-header-content'
          onClick={(e) => {
            e.stopPropagation();
            onElementSelect(element);
          }}>
          <span className='element-type-icon'>{FORM_ICONS_UPDATED["table"]}</span>
          <span className='table-title'>Table</span>
        </div>
      </div>

      {/* Table Content */}
      <div className='table-container-inner'>
        <TableFormField element={element} onFieldPropertiesChange={onElementUpdate} />
      </div>
    </div>
  );
};

export default TableContainer;
